import { PROMO } from "./promo"
import { LISTAS } from "./listas"
import { ALBUM } from "./album"
import { ARTIST } from "./artist"
import { DESCUBRE } from "./reels"

/* =========================
   EXPORTS INDIVIDUALES
========================= */

export {
  PROMO,
  LISTAS,
  ALBUM,
  ARTIST,
  DESCUBRE,
}

/* =========================
   PLAYLIST GLOBAL
========================= */

export const PLAYLIST = [
  ...LISTAS,
  ...ALBUM,
  ...ARTIST,
  ...PROMO,
  ...DESCUBRE,
]
